import { AddEditAdditionalEntryMaterialMapping, AddEditGRNEntryMaterialMapping, AddEditInquiryDetails, AddEditPurchaseOrderDetails, AddEditPurchaserOrderMaterialDetails, ApprovePurchaseOrderByPurchaseId, DeleteAdditionalEntryDetailsById, DeleteAdditionalEntryMaterialDetailsById, DeleteGRNEntryMaterialDetailsById, DeleteInquiryDetailsById, DeleteInquiryMaterialDetailsById, DeleteItemforGRNEntryMaterialById, DeletePurchaseOrderDetailsById, DeletepurchaseOrderMaterialDetialsById, GetAllAdditionalEntryList, GetAllAdditionalEntryMaterialDetailsById, GetAllGoodsRegistered, GetAllgrnEntryMaterialDetailsById, GetallInquiryDetails, GetAllInquiryMaterialDetailsByInquiryId, GetAllItemsForStockLedgerReport, GetAllMaterialWisePurchaseReport, GetAllNearExpiryReport, GetAllPartyListForGRNEntry, GetAllPurchaseOrderRegister, GetAllPurchaseOrders, GetAllShourtageReport, GetAllStatementForPurchaseItemByItemId, GetGRNNo, GetPurchaseOrderMaterialByPartyId, GetPurchaseOrderMaterialDetailsByPurchaseOrderId, SendInquiryToCompany, SendPurchaseOrderMail } from "../ApiEndPoints.js";
import { axiosGetWithencryption, axiosPostWithencryption } from "../AxiosRequests.js";


export default class InventoryServices {

    // G.R.N Entry
    async getGRNNo(request) {
        return axiosGetWithencryption(GetGRNNo, request);
    }

    async addEditGRNEntryMaterialMapping(request) {
        return axiosPostWithencryption(AddEditGRNEntryMaterialMapping, request);
    }

    async getAllPartyListForGRNEntry(request) {
        return axiosPostWithencryption(GetAllPartyListForGRNEntry, request);
    }

    async getAllgrnEntryMaterialDetailsById(request) {
        return axiosGetWithencryption(GetAllgrnEntryMaterialDetailsById, request);
    }

    async getPurchaseOrderMaterialByPartyId(request) {
        return axiosPostWithencryption(GetPurchaseOrderMaterialByPartyId, request);
    }

    async deleteGRNEntryMaterialDetailsById(request) {
        return axiosGetWithencryption(DeleteGRNEntryMaterialDetailsById, request);
    }

    async deleteItemforGRNEntryMaterialById(request) {
        return axiosGetWithencryption(DeleteItemforGRNEntryMaterialById, request);
    }

    // Additional Entry
    async addEditAdditionalEntryMaterialMapping(request) {
        return axiosPostWithencryption(AddEditAdditionalEntryMaterialMapping, request);
    }

    async getAllAdditionalEntryMaterialDetailsById(request) {
        return axiosGetWithencryption(GetAllAdditionalEntryMaterialDetailsById, request);
    }

    async getAllAdditionalEntryList(request) {
        return axiosPostWithencryption(GetAllAdditionalEntryList, request);
    }

    async deleteAdditionalEntryDetailsById(request) {
        return axiosGetWithencryption(DeleteAdditionalEntryDetailsById, request);
    }

    async deleteAdditionalEntryMaterialDetailsById(request) {
        return axiosGetWithencryption(DeleteAdditionalEntryMaterialDetailsById, request);
    }

    // Purchase Order
    async addEditPurchaseOrderDetails(request) {
        return axiosPostWithencryption(AddEditPurchaseOrderDetails, request);
    }

    async getAllPurchaseOrders(request) {
        return axiosPostWithencryption(GetAllPurchaseOrders, request);
    }

    async addEditPurchaserOrderMaterialDetails(request) {
        return axiosPostWithencryption(AddEditPurchaserOrderMaterialDetails, request);
    }

    async getPurchaseOrderMaterialDetailsByPurchaseOrderId(request) {
        return axiosGetWithencryption(GetPurchaseOrderMaterialDetailsByPurchaseOrderId, request);
    }

    async deletePurchaseOrderDetailsById(request) {
        return axiosGetWithencryption(DeletePurchaseOrderDetailsById, request);
    }

    async deletepurchaseOrderMaterialDetialsById(request) {
        return axiosGetWithencryption(DeletepurchaseOrderMaterialDetialsById, request);
    }

    async sendPurchaseOrderMail(request) {
        return axiosPostWithencryption(SendPurchaseOrderMail, request);
    }

    async approvePurchaseOrderByPurchaseId(request) {
        return axiosGetWithencryption(ApprovePurchaseOrderByPurchaseId, request);
    }

    // Inquiry Entry
    async addEditInquiryDetails(request) {
        return axiosPostWithencryption(AddEditInquiryDetails, request);
    }

    async getallInquiryDetails(request) {
        return axiosPostWithencryption(GetallInquiryDetails, request);
    }

    async getAllInquiryMaterialDetailsByInquiryId(request) {
        return axiosGetWithencryption(GetAllInquiryMaterialDetailsByInquiryId, request);
    }

    async deleteInquiryDetailsById(request) {
        return axiosGetWithencryption(DeleteInquiryDetailsById, request);
    }

    async deleteInquiryMaterialDetailsById(request) {
        return axiosGetWithencryption(DeleteInquiryMaterialDetailsById, request);
    }

    async sendInquiryToCompany(request) {
        return axiosPostWithencryption(SendInquiryToCompany, request);
    }

    // Reports
    async getAllGoodsRegistered(request) {
        return axiosPostWithencryption(GetAllGoodsRegistered, request);
    }

    async getAllMaterialWisePurchaseReport(request) {
        return axiosPostWithencryption(GetAllMaterialWisePurchaseReport, request);
    }

    async getAllItemsForStockLedgerReport(request) {
        return axiosPostWithencryption(GetAllItemsForStockLedgerReport, request);
    }

    async getAllStatementForPurchaseItemByItemId(request) {
        return axiosPostWithencryption(GetAllStatementForPurchaseItemByItemId, request);
    }

    async getAllShourtageReport(request) {
        return axiosPostWithencryption(GetAllShourtageReport, request);
    }

    async getAllNearExpiryReport(request) {
        return axiosPostWithencryption(GetAllNearExpiryReport, request);
    }

    async getAllPurchaseOrderRegister(request) {
        return axiosPostWithencryption(GetAllPurchaseOrderRegister, request);
    }
}

